export const ADSS_ADVANCED_MD_CONFIG = {
  officeKey: "141444",
  appName: "VALERIEHEALTH",
  credentialsSecretName: "AMD_LOGIN__PRODUCTION",
  selfPayFinancialClassCode: "SP",
  defaultProfileId: "146",
  homeOnlyPhoneAsMobile: true,
} as const;
